import axios from 'axios';
import { retrieveCompanyName } from '../routerPagesManager/routerPagesManager';

/* eslint-disable */
export function authHeader(formData) {
  const { token } = localStorage.getItem('token')
    ? JSON.parse(localStorage.getItem('token'))
    : false;
  if (formData === true) {
    return token
      ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        }
      : { 'Content-Type': 'application/json', Accept: 'application/json' };
  } else {
    return token
      ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }
      : { 'Content-Type': 'application/json', Accept: 'application/json' };
  }
}

export function headerNoAuth() {
  return {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': true,
  };
}

function defineUrlBase() {
  const companyName = retrieveCompanyName();
  const apiBase = process.env.REACT_APP_API;
  const protocol = companyName.endsWith('-st') ? 'http' : 'https';

  if (companyName !== 'localhost') {
    return { baseURL: `${protocol}://${companyName}.${apiBase}` };
  } else {
    return { baseURL: `${protocol}://${apiBase}` };
  }
}

export default axios.create(defineUrlBase());
